module.exports = __webpack_public_path__ + "static/media/loginLogo.b6c32cff.svg";